import useNetwork from '@/hooks/useNetwork';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    evaluationEventEducator: network?.id ? {
      $where: {
        event: {
          $where: {
            networkId: network.id
          }
        }
      }
    } : undefined
  };
};
